var React = require('react');

function Briefing (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.47,1.3V16.36H16.53V1.3ZM9,11.35H5v-2H9ZM12,6.5H5v-2h7Z"}));
}

Briefing.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 18 18"};

module.exports = Briefing;

Briefing.default = Briefing;
